import * as React from 'react';
import Button from '@mui/material/Button';

export default function BasicButtons({ type, text, color }) {
    return (
        <Button variant={type} color={color}> {text}</Button >
    );
}